import { createReduxModule } from 'react-eventr'

import { HubEvent } from '../redux/notifications'
import { NotificationType } from '../redux/account/notifications'

export const { EventrActions, addEvent, addEvents, useReduxEvent, useReduxEvents } = createReduxModule<
  NotificationType,
  HubEvent
>()
